const constants = window.App.constants;

const user = window.App.user || {
  id: null,
  hvac_id: null,
  first_name: "",
  last_name: "",
  access_level: 0,
  is_contact: 0,
  is_authorized_trainer: 0,
  trainer_type: "",
  is_icp_dealer: 0,
};

const company = window.App.company || {
  id: null,
  type: constants.PUBLIC_COMPANY,
  name: "",
};

const brand = window.App.brand || {
  id: null,
  name: "",
};

export default {
  namespaced: true,
  state: {
    user: user,
    company: company,
    brand: brand,
  },
  mutations: {},
  actions: {},
  getters: {
    isLoggedIn: ({ user }) => {
      return user.id ? true : false;
    },
    isSuperUser: ({ user }) => {
      return user.access_level == constants.SUPER_USER;
    },
    isAdmin: ({ user }) => {
      return (
        user.access_level == constants.ADMIN_USER ||
        user.access_level == constants.SUPER_USER
      );
    },
    isManager: ({ user }) => {
      return user.access_level == constants.MANAGER_USER;
    },
    isStudent: ({ user }) => {
      return user.access_level == constants.STUDENT_USER;
    },
    isPublicUser: ({ user }) => {
      return user.access_level == constants.PUBLIC_USER;
    },
    isTrainer: ({ user }) => {
      return user.trainer_type ? true : false;
    },
    isFactoryTrainer: ({ user }) => {
      return user.trainer_type == constants.FACTORY_TRAINER;
    },
    isExternalTrainer: ({ user }) => {
      return user.trainer_type == constants.EXTERNAL_TRAINER;
    },
    isDistributorTrainer: ({ user }) => {
      return user.trainer_type == constants.DISTRIBUTOR_TRAINER;
    },
    isAuthorizedTrainer: ({ user }) => {
      return (
        user.trainer_type == constants.AUTHORIZED_TRAINER ||
        !!user.is_authorized_trainer
      );
    },
    isLocalContact: ({ user }) => {
      return !!user.is_contact;
    },
    isDealer: ({ company }) => {
      return company.type == constants.DEALER_COMPANY;
    },
    isDistributor: ({ company }) => {
      return company.type == constants.DISTRIBUTOR_COMPANY;
    },
    isFactory: ({ company }) => {
      return company.type == constants.FACTORY_COMPANY;
    },
    isIcpDealer: ({ user }) => {
      return !!user.is_icp_dealer;
    },
    isAdminager: ({ user }) => {
      return (
        user.access_level == constants.ADMIN_USER ||
        user.access_level == constants.SUPER_USER ||
        user.access_level == constants.MANAGER_USER
      );
    },
  },
};
